import { Params } from '@/components/table'

export const paramsApdapter = (res?: Params) => {
  if (!res) return undefined

  const limit = res.pageSize || 10
  const cur = res.current || 1
  return {
    limit,
    offset: (cur - 1) * limit,
    order: res.order,
    key: res.sort
  }
}
